import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAlertasUsuariosEncaminhados } from "./services";

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

type GetAlertasUsuariosEncaminhadosParams = {
  idLoja: number | null;
  idRegional: number;
  idCliente: number;
};

export const actionGetAlertasUsuariosEncaminhados = createAsyncThunk(
  "ACTION_GET_ALERTA_USUARIOS_ENCAMINHADOS",
  async ({
    idLoja,
    idRegional,
    idCliente,
  }: GetAlertasUsuariosEncaminhadosParams) => {
    console.log("actionGetAlertasUsuariosEncaminhados");
    return getAlertasUsuariosEncaminhados(idLoja, idRegional, idCliente);
  },
);

const sliceGetAlertasUsuariosEncaminhados = createSlice({
  name: "GET_ALERTA_USUARIOS_ENCAMINHADOS",
  initialState,
  reducers: {
    actionResetGetAlertasUsuariosEncaminhados: (state) => {
      state.status = "";
      state.data = [];
    },
  },
  extraReducers: {
    [`${actionGetAlertasUsuariosEncaminhados.pending}`]: (state) => {
      state.status = "loading";
    },
    [`${actionGetAlertasUsuariosEncaminhados.fulfilled}`]: (
      state,
      { payload },
    ) => {
      state.status = "success";
      state.data = payload;
    },
    [`${actionGetAlertasUsuariosEncaminhados.rejected}`]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetAlertasUsuariosEncaminhados.reducer;
export const { actionResetGetAlertasUsuariosEncaminhados } =
  sliceGetAlertasUsuariosEncaminhados.actions;
